export var ApplicableLawState;
(function (ApplicableLawState) {
    ApplicableLawState["NO_ACTION"] = "noAction";
    ApplicableLawState["BEST_PRACTICE_REQUIREMENTS"] = "bestPracticeRequirements";
    ApplicableLawState["IMPROVE_LEGAL_PRACTICE"] = "improveLegalPractice";
    ApplicableLawState["DISCLOSURE_REQUIREMENTS"] = "disclosureRequirements";
})(ApplicableLawState || (ApplicableLawState = {}));
//# sourceMappingURL=types.js.map